import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Table from 'web-app/react/components/table/model';

export const fetchPublicFundingReport = (
    institutionId,
    from,
    to,
    filter,
    fundingTypeIds,
    ageInMonthsLower,
    ageInMonthsUpper,
) =>
    RESTClient.getAuthenticatedObservable('v2/public-funding/report', {
        includeCsvLink: true,
        institutionId,
        from,
        to,
        filter,
        fundingTypeIds,
        ageInMonthsLower,
        ageInMonthsUpper,
    }).map(response => ({
        csv: response.csv,
        table: Table.fromAPI(response.table),
        fundingLoop: response.fundingLoop,
    }));

export const updatePlanFundingTypes = (planId, fundingTypeIds) =>
    RESTClient.putAuthenticatedObservable(`v2/plans/${planId}/fundingTypes`, {
        fundingTypeIds,
    });
